module.exports = __webpack_public_path__ + "img/pagination_btn_left_icon.2da607f8.svg";